/**
 * Canonical consumer disclaimer copy (PLA2-338).
 *
 * Kept in a plain module (no React/icons) so it can be shared by the
 * `AiInspirationDisclaimer` component (UI surfaces: designer, generated design,
 * checkout) and the design-email route (the email template is external and not
 * React) without pulling component/icon code into the server bundle.
 */
export const AI_INSPIRATION_DISCLAIMER =
  "AI-generated for inspiration. Actual plants, sizes, and placement will vary by season and site conditions.";

/**
 * Horticultural + legal notes — spacing/suitability + 811 (call-before-you-dig)
 * + HOA (PLA2-371 / PLA2-352). Shown on designs, the design email, and checkout.
 * The UI lists the items individually (PLA2-765); the email uses the joined string.
 */
export const SPACING_811_HOA_ITEMS = [
  "Plant spacing, mature size, and suitability vary by site conditions (soil, light, drainage) and local climate.",
  "Before you dig, call 811 or visit call811.com to have underground utilities marked. It's free and required by law in most areas.",
  "Confirm plant placement against local guidelines and any HOA rules before planting.",
] as const;

export const SPACING_811_HOA_DISCLAIMER = SPACING_811_HOA_ITEMS.join(" ");

/** Container-garden version of the notes: no digging, so no 811 / HOA. */
export const CONTAINER_PLANTING_ITEMS = [
  "Plant counts and mature sizes vary by plant, season and how the pot is cared for.",
  "Use a planter with drainage holes and fresh potting mix; garden soil compacts in a pot.",
  "A filled planter is heavy. Place it before watering, and check that balconies and decks can carry the weight.",
] as const;
